import { push } from 'react-router-redux';
import acs from '@mos-utils/acs';

import { fetchPOST } from '../../resources/fetchHelper';
import { APPLICANT_TYPES } from '../../constants/applicant';
import {
  appealDataRequestStructureSelector,
  appealDataRequestParentStructureSelector
} from './selectors';
import { applicantTypeSelector } from '../applicant/selectors';
import { getUserSnilsSelector } from '../mainData/selectors';
import { deleteDraft } from '../draft/actions';

import {
  REQUEST_APPEAL_SUCCESS,
  REQUEST_APPEAL_SUBMIT,
  REQUEST_APPEAL_ERROR,
  REQUEST_APPEAL_ALREADY_REPORTED,
  FIND_APPEAL
} from '../constants';
import apiRoutes from '../../resources/apiRoutes';
import {
  sendStats,
  TRACK_REQUEST_APPEAL_SUCCESS
} from '../../resources/metrics';

import {
  sendCMAAppealBusinessError,
  sendCMAAppealFinish,
  sendCMAAppealTechError
} from '../../helpers/CMAStats';
import ACSBroadcast from '../../helpers/ACSBroadcast';

import { appealSubmitParticipantSelector } from '../gia/selectors';
import { examIdSelector, currentExamSelector } from '../examData/selectors';
import { getUserSnilsSelector as getChildSnilsSelector } from '../mainDataChild/selectors';

import { snilsValidate } from '../../services/validationRules';

import { getFindAppeal } from '../../resources';

export default function submitAppeal(payload = {}) {
  return (dispatch, getState) => {
    dispatch({ type: REQUEST_APPEAL_SUBMIT });

    const state = getState();
    const applicantType = applicantTypeSelector(state);

    let appealData;

    if (applicantType === APPLICANT_TYPES.parent) {
      appealData = appealDataRequestParentStructureSelector(state);
    } else {
      appealData = appealDataRequestStructureSelector(state);
    }

    const { registration_code } = appealSubmitParticipantSelector(state);
    const examId = payload.examId || examIdSelector(state);

    const { type, subject_code, date } = currentExamSelector({
      ...state,
      examData: {
        ...state.examData,
        examId
      }
    });

    const onMessage = message => {
      const snils = getUserSnilsSelector(state);
      const normSnils = input => input.replace(/[^\d]/g, '');

      if (
        message.type === 'PROFILE_UPDATED' &&
        normSnils(snils) === normSnils(message.profile.snils)
      ) {
        ACSBroadcast.unsubscribe(onMessage);

        const onError = error => {
          sendCMAAppealTechError({ stage: 'final' });
          dispatch({ type: REQUEST_APPEAL_ERROR, error });
        };

        try {
          let snils;

          if (payload.snils) {
            snils = payload.snils;
          } else if (applicantType === APPLICANT_TYPES.parent) {
            snils = getChildSnilsSelector(state);
          } else {
            snils = getUserSnilsSelector(state);
          }

          if (snils && snils.match(snilsValidate.pattern)) {
            getFindAppeal({
              snils,
              exam_type: type,
              subject_code,
              reg_code: registration_code,
              exam_date: date
            })
              .then(response => {
                if (response.code === 'SUCCESS' || response.code === 'OK') {
                  return new Promise((resolve, reject) => {
                    if (response.data.application === false) {
                      return resolve();
                    } else {
                      return reject(REQUEST_APPEAL_ALREADY_REPORTED);
                    }
                  });
                }
                return response;
              })
              .then(() => {
                return fetchPOST(apiRoutes.getAppealSubmitUrl(), appealData);
              })
              .then(response => {
                if (response.code === 'SUCCESS' || response.code === 'OK') {
                  dispatch({
                    type: REQUEST_APPEAL_SUCCESS,
                    payload: {
                      ...response,
                      action: 'submit'
                    }
                  });
                  dispatch(deleteDraft());
                  sendStats(TRACK_REQUEST_APPEAL_SUCCESS());
                  sendCMAAppealFinish();
                  dispatch(push('/success-submit/'));
                } else if (response.code === 'ALREADY_REPORTED') {
                  sendCMAAppealBusinessError({ stage: 'final' });
                  dispatch({
                    type: REQUEST_APPEAL_ALREADY_REPORTED,
                    payload: 'appeal'
                  });
                } else {
                  onError(response.message);
                }
                return response;
              })
              .catch(error => {
                if (REQUEST_APPEAL_ALREADY_REPORTED) {
                  dispatch({
                    type: error,
                    payload: 'appeal'
                  });
                  return;
                }
                onError();
              });
          }
        } catch (error) {
          onError(error);
        }
      }
    };

    ACSBroadcast.subscribe(onMessage);
    acs.refetchProfile();
  };
}
